exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".component.table table {\n  width: 100%;\n  font-size: 12px;\n  color: white; }\n\n.component.table table, .component.table th, .component.table td {\n  border-collapse: collapse;\n  border: 1px solid white; }\n\n.component.table th, .component.table td {\n  padding: 0.4rem 0.6rem; }\n\n.component.table th {\n  font-style: italic;\n  background: rgba(255, 255, 255, 0.12); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/table/table.scss
// module id = 186
// module chunks = 0